module.exports = __webpack_public_path__ + "56780afa2ccb99bbbe223f18ec8cf136.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/home-head-bg.png
// module id = 533
// module chunks = 0